// El interruptor de WhatsApp de Configuración → Notificaciones
// (ADR-2026-11-02-interruptor-de-whatsapp).
//
// La preferencia vive en `contact_preferences.whatsapp_opt_out_at`, una tabla del motor de mails
// (atlas-mails, migración 010) cerrada para la API. La app la lee y la cambia SÓLO con dos funciones
// de la base que toman a la persona de su sesión (`auth.uid()`): nunca se le pasa un id.
//
// Arranca prendido: sin fila, o con la fecha nula, le llegan los WhatsApp. Los manda el schedule de
// Claude (retención), que saltea a quien lo apagó.

import { supabase } from './supabase';

/**
 * ¿Le llegan los WhatsApp de Atlas? `null` si no se pudo saber (por ejemplo, la migración todavía
 * no está aplicada): la pantalla entonces no muestra el interruptor, en vez de mostrar uno que
 * no guarda.
 */
export async function leerRecibeWhatsApp(): Promise<boolean | null> {
  try {
    const { data, error } = await supabase.rpc('mensajeria_whatsapp_recibe');
    if (error || typeof data !== 'boolean') return null;
    return data;
  } catch {
    return null;
  }
}

/** Prende (`true`) o apaga (`false`) los WhatsApp. Devuelve si se guardó. */
export async function cambiarRecibeWhatsApp(recibir: boolean): Promise<boolean> {
  try {
    const { data, error } = await supabase.rpc('mensajeria_whatsapp_cambiar', { recibir });
    return !error && data === recibir;
  } catch {
    return false;
  }
}
